import {
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST,
    PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT,
    PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST,
    PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT,
    PACKAGES_FEATURES_SET_ROLE_MODULES,
} from 'Redux/actionTypes';

export const packagesFeaturesSetRoleModules = (items) => ({
    type: PACKAGES_FEATURES_SET_ROLE_MODULES,
    payload: items
})

export const packagesFeaturesSearchRoleModulesRequest = (id) => ({
    type: PACKAGES_FEATURES_SEARCH_ROLE_MODULES_REQUEST,
    payload: id
})

export const packagesFeaturesSearchRoleModulesResult = (result) => ({
    type: PACKAGES_FEATURES_SEARCH_ROLE_MODULES_RESULT,
    payload: result
})

export const packagesFeaturesSearchRoleModulesByIdRequest = (id) => ({
    type: PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_REQUEST,
    payload: id
})

export const packagesFeaturesSearchRoleModulesByIdResult = (result) => ({
    type: PACKAGES_FEATURES_SEARCH_ROLE_MODULES_BY_ID_RESULT,
    payload: result
})

export const packagesFeaturesUpdateRoleModulesRequest = (data) => ({
    type: PACKAGES_FEATURES_UPDATE_ROLE_MODULES_REQUEST,
    payload: data
})

export const packagesFeaturesUpdateRoleModulesResult = (result) => ({
    type: PACKAGES_FEATURES_UPDATE_ROLE_MODULES_RESULT,
    payload: result
})